import { DocTitle } from './doc-title';

export * from './doc-title';

export function effects() {
  customElements.define('hive-linked-doc-title', DocTitle);
}
